import Sidebar from "./sidebar";
import Header from "./header";
import Footer from "./footer";
import { RWebShare } from "react-web-share";
import "./style.css";
import { useNavigate, useParams } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  requestAdminAddCourse,
  requestAdminAllCourse,
  requestAdminCourse, requestAdminAllDegree,
  requestAdminDeleteCourse,
  requestAdminEditCourse,
} from "../Redux/actions";
import Swal from "sweetalert2";

function Course(props) {

  const [pagination, setpagination] = useState({});
  const navigate = useNavigate();
  const [change, setchange] = useState(false)
  const [pages, setpages] = useState([]);
  const [page_size, setpage_size] = useState(0);
  const [error, seterror] = useState("");
  const [id, setid] = useState(0);
  const [course, setcourse] = useState([]);
  const [degree, setdegree] = useState([]);
  const [adddata, setadddata] = useState({
    name: "", degree_id: 0,
  });
  const [editdata, seteditdata] = useState({
    name: "", degree_id: 0,
  });
  const params = useParams();
  const [addmodal, setaddModal] = useState(false);
  const [editmodal, seteditModal] = useState(false);
  const [errordegree, seterrordegree] = useState("");

  useEffect(() => {
    props.requestAdminAllDegree({
      page: 1,
      page_size: 200,
    });
  }, [1, 200]);

  useEffect(() => {
    let allDegreeData = props.data.allDegreeData;
    if (allDegreeData !== undefined) {
      if (allDegreeData.data) {
        setdegree(allDegreeData.data.data);
      }
    }
  }, [props.data.allDegreeData]);

  function validateadd() {
    let formIsValid = false;
    if (!adddata["name"]) {
      formIsValid = false;
      seterror("*Enter Course Name.");
    }
    else {
      formIsValid = true;
    }
    return formIsValid;
  }

  function validatedegree() {
    let formIsValid = false;
    if (adddata["degree_id"] === "0") {
      formIsValid = false;
      seterrordegree("*Select degree.");
    } else if (typeof adddata["degree_id"] === "undefined") {
      formIsValid = false;
      seterrordegree("*Select degree.");
    } else {
      formIsValid = true;
      seterrordegree("");
    }
    return formIsValid;
  }

  function validateAddForm() {
    let validate = validateadd(); let degree = validatedegree();
    let valid = validate && degree;
    return valid;
  }

  function validateedit() {
    let formIsValid = false;
    if (!editdata["name"]) {
      formIsValid = false;
      seterror("*Enter Course Name.");
    }
    else {
      formIsValid = true;
    }
    return formIsValid;
  }

  function validateeditdegree() {
    let formIsValid = false;
    if (editdata["degree_id"] === "0") {
      formIsValid = false;
      seterrordegree("*Select degree.");
    } else if (typeof editdata["degree_id"] === "undefined") {
      formIsValid = false;
      seterrordegree("*Select degree.");
    } else {
      formIsValid = true;
      seterrordegree("");
    }
    return formIsValid;
  }

  function validateEditForm() {
    let validate = validateedit(); let degree = validateeditdegree();
    let valid = validate && degree;
    return valid;
  }

  function onchangeadddata(e) {
    setadddata((adddata) => ({
      ...adddata,
      [e.target.name]: e.target.value,
    }));
  }

  function onchangeeditdata(e) {
    seteditdata((editdata) => ({
      ...editdata,
      [e.target.name]: e.target.value,
    }));
  }

  const addtoggle = () => setaddModal(!addmodal);
  const saveaddtoggle = (e) => {
    e.preventDefault();
    if (validateAddForm()) {
      props.requestAdminAddCourse({
        data: {
          name: adddata.name,
          degree_id: adddata.degree_id,
        },
      });
      setadddata({
        name: "",
        degree_id: 0
      });
      addtoggle();
    }
  };

  useEffect(() => {
    let addCourseData = props.data.addCourseData;
    if (addCourseData !== undefined) {
      if (addCourseData.data) {
        Swal.fire({
          title: 'Good job!',
          text: 'Course name added successfully..',
          icon: 'success'
        });
        setchange(!change)
      }
    }
    props.data.addCourseData = undefined;
  }, [props.data.addCourseData]);

  const edittoggle = (id) => {

    if (editmodal === true) {
      seteditModal(!editmodal);
    } else {
      seteditModal(!editmodal);
      setid(id);
      seteditdata({
        name: " ",
        degree_id: 0,
      });
      props.requestAdminCourse({
        id: id,
      });
    }
  };

  useEffect(() => {
    let course = props.data.courseData;
    if (course !== undefined) {
      if (course.data) {
        console.log(course.data.data.Course[0]);
        seteditdata(course.data.data.Course[0]);
      }
    }
  }, [props.data.courseData]);

  const saveedittoggle = (e) => {
    e.preventDefault();

    if (validateEditForm()) {
      props.requestAdminEditCourse({
        id: id,
        data: {
          name: editdata.name,
          degree_id: editdata.degree_id,
        },
      });
      seteditdata({
        name: "",
        degree_id: 0,
      });
      setid(0);
      edittoggle();
    }
  };

  useEffect(() => {
    let editCourseData = props.data.editCourseData;
    if (editCourseData !== undefined) {
      if (editCourseData.data) {
        Swal.fire({
          title: 'Good job!',
          text: 'Course name updated successfully..',
          icon: 'success'
        });
        setchange(!change)
      }
    }
    props.data.editCourseData = undefined;
  }, [props.data.editCourseData]);

  useEffect(() => {
    props.requestAdminAllCourse({
      page: params.page,
      page_size: params.page_size,
    });
    setpage_size(params.page_size);
  }, [params.page, params.page_size, change]);

  function onChangePageSize(e) {
    setpage_size(e.target.value);
    if (e.target.value > 0) {
      navigate(`/admin/course/1/${e.target.value}`);
    }
  }

  useEffect(() => {
    let allCourseData = props.data.allCourseData;
    if (allCourseData !== undefined) {
      if (allCourseData.data) {
        setcourse(allCourseData.data.data);
        setpagination(allCourseData.data.meta);
        if (allCourseData.data.meta.last_page < 5) {
          let array = [];
          Array.from(Array(allCourseData.data.meta.last_page), (e, i) => {
            array.push(i + 1);
          });
          setpages(array);
        } else {
          let array = [];
          if (allCourseData.data.meta.current_page <= 3) {
            array.push(1, 2, 3, 4, 5);
            setpages(array);
          } else if (
            allCourseData.data.meta.last_page - allCourseData.data.meta.current_page <=
            2
          ) {
            array.push(
              allCourseData.data.meta.last_page - 4,
              allCourseData.data.meta.last_page - 3,
              allCourseData.data.meta.last_page - 2,
              allCourseData.data.meta.last_page - 1,
              allCourseData.data.meta.last_page
            );
            setpages(array);
          } else {
            array.push(
              Number(allCourseData.data.meta.current_page) - 2,
              Number(allCourseData.data.meta.current_page) - 1,
              allCourseData.data.meta.current_page,
              Number(allCourseData.data.meta.current_page) + 1,
              Number(allCourseData.data.meta.current_page) + 2
            );
            setpages(array);
          }
        }
      }
    }
  }, [props.data.allCourseData]);

  const CustomUI = ({ onSubmit, onCancel }) => (
    <div
      className="custom-ui"
      style={{
        backgroundColor: "white",
        width: "350px",
        padding: "25px",
        border: "1px solid black",
        margin: "auto",
      }}
    >
      <h3>Are you sure?</h3>
      <p>
        Do you really want to delete this records? This process cannot be
        undone.
      </p>
      <div>
        <button
          onClick={onSubmit}
          style={{ border: "0px", backgroundColor: "green", color: "white", padding: "2px 10px" }}
        >
          Yes
        </button>
        <button
          onClick={onCancel}
          style={{
            border: "0px",
            backgroundColor: "red",
            color: "white",
            marginLeft: "10px",
            padding: "2px 10px"
          }}
        >
          No
        </button>
      </div>
    </div>
  );
  function deletedata(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        props.requestAdminDeleteCourse({
          id: id,
        });
      }
    })
  }

  useEffect(() => {
    let deleteCourseData = props.data.deleteCourseData;
    if (deleteCourseData !== undefined) {
      if (deleteCourseData.data) {
        Swal.fire({
          title: 'Good job!',
          text: 'Course name deleted successfully..',
          icon: 'success'
        });
        setchange(!change)
      }
    }
    props.data.deleteCourseData = undefined;
  }, [props.data.deleteCourseData]);

  function printPage() {
    var printContents =
      "<br/><center><h3>Courses</h3></center>" +
      document.getElementById("printme").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }

  return (
    <>
      <div class="container-scroller">
        <Header name="Course names" />
        <div class="container-fluid page-body-wrapper">
          <Sidebar name="Options" />

          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-sm-12">
                  <div class="home-tab">
                    <div class="row flex-grow">
                      <div class="col-12 grid-margin stretch-card">
                        <div class="card card-rounded">
                          <div class="card-body">
                            <div class="d-sm-flex justify-content-between align-items-start">
                              <div class="btn-wrapper">
                                <RWebShare
                                  data={{
                                    text: "Job Portal",
                                    url: `http://localhost:3000/admin/course/${params.page}/${params.page_size}`,
                                    title: "Job Portal",
                                  }}
                                >
                                  <p class="btn btn-otline-dark align-items-center">
                                    <i class="icon-share"></i> Share
                                  </p>
                                </RWebShare>
                                <button
                                  onClick={printPage}
                                  class="btn btn-otline-dark"
                                >
                                  <i class="icon-printer"></i> Print
                                </button>
                              </div>
                              <div>
                                <button
                                  class="btn btn-primary btn-md text-white mb-0 me-0"
                                  type="button"
                                  onClick={addtoggle}
                                >
                                  Add new course
                                </button>
                                <Modal isOpen={addmodal} toggle={addtoggle}>
                                  <ModalHeader toggle={addtoggle}>
                                    Add Course names
                                  </ModalHeader>
                                  <ModalBody>
                                    <form class="forms-sample">
                                      <div class="form-group">
                                        <label>Degree Level</label>
                                        <select
                                          class="form-select"
                                          name="degree_id"
                                          value={adddata.degree_id}
                                          onBlur={validatedegree}
                                          onChange={onchangeadddata}
                                        >
                                          <option value="0">Select Degree</option>
                                          {degree.map((option) => (
                                            <option value={option.id}>
                                              {option.level}
                                            </option>
                                          ))}
                                        </select>
                                        {errordegree && <p>{errordegree}</p>}
                                      </div>

                                      <div class="form-group">
                                        <label>Course Name</label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          placeholder="name"
                                          name="name"
                                          value={adddata.name}
                                          onBlur={validateadd}
                                          onChange={onchangeadddata}
                                        />
                                        {error && <p>{error}</p>}
                                      </div>

                                      <button
                                        type="submit"
                                        class="btn btn-primary me-2"
                                        onClick={saveaddtoggle}
                                      >
                                        Submit
                                      </button>
                                      <button
                                        class="btn btn-light"
                                        onClick={addtoggle}
                                      >
                                        Cancel
                                      </button>
                                    </form>
                                  </ModalBody>
                                </Modal>
                              </div>
                            </div>
                            <br />
                            <div class="table-responsive  mt-1" id="printme">
                              <table class="table select-table">
                                <thead>
                                  <tr>
                                    <th>name</th>
                                    <th>Created At</th>
                                    <th>Updated At</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {course.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          <div class="d-flex ">
                                            <div>
                                              <h6>{item.name}</h6>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <p>{item.created_at !== null ? item.created_at.substring(0, 10) : ''}</p>
                                        </td>
                                        <td>
                                          <p>{item.updated_at !== null ? item.updated_at.substring(0, 10) : ''}</p>
                                        </td>
                                        <td>
                                          <button
                                            class="badge badge-opacity-success"
                                            style={{
                                              border: "0px",
                                              marginLeft: "5px",
                                            }}
                                            onClick={() => {
                                              edittoggle(item.id);
                                            }}
                                          >
                                            <i class="fa fa-pencil-square-o"></i>
                                          </button>
                                          {editmodal === true && (
                                            <Modal
                                              isOpen={editmodal}
                                              toggle={edittoggle}
                                            >
                                              <ModalHeader toggle={edittoggle}>
                                                Edit Course names
                                              </ModalHeader>
                                              <ModalBody>
                                                <form class="forms-sample">
                                                  <div class="form-group">
                                                    <label>Degree Level</label>
                                                    <select
                                                      class="form-select"
                                                      name="degree_id"
                                                      value={editdata.degree_id}
                                                      onBlur={validateeditdegree}
                                                      onChange={onchangeeditdata}
                                                    >
                                                      <option value="0">Select Degree</option>
                                                      {degree.map((option) => (
                                                        <option value={option.id}>
                                                          {option.level}
                                                        </option>
                                                      ))}
                                                    </select>
                                                    {errordegree && <p>{errordegree}</p>}
                                                  </div>

                                                  <div class="form-group">
                                                    <label>Course Name</label>
                                                    <input
                                                      type="text"
                                                      class="form-control"
                                                      placeholder="name"
                                                      name="name"
                                                      value={editdata.name}
                                                      onBlur={validateedit}
                                                      onChange={
                                                        onchangeeditdata
                                                      }
                                                    />
                                                    {error && <p>{error}</p>}
                                                  </div>

                                                  <button
                                                    type="submit"
                                                    class="btn btn-primary me-2"
                                                    onClick={saveedittoggle}
                                                  >
                                                    Submit
                                                  </button>
                                                  <button
                                                    class="btn btn-light"
                                                    onClick={edittoggle}
                                                  >
                                                    Cancel
                                                  </button>
                                                </form>
                                              </ModalBody>
                                            </Modal>
                                          )}
                                          <button
                                            class="badge badge-opacity-danger"
                                            style={{
                                              border: "0px",
                                              background: "#fea8a9",
                                              marginLeft: "5px",
                                            }}
                                            onClick={() => {

                                              deletedata(item.id);

                                            }}
                                          >
                                            <i class="fa fa-trash"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>

                            <div class="row">
                              <div class="col-10">
                                <div class="pagination center">
                                  <ul class="pagination-list">
                                    {pagination.current_page !== 1 && (
                                      <li>
                                        <a
                                          href={`/admin/course/${params.page - 1}/${params.page_size
                                            }`}
                                        >
                                          <i class="fa fa-long-arrow-left"></i>
                                        </a>
                                      </li>
                                    )}
                                    {pages.map((i) => {
                                      return pagination.current_page === i ? (
                                        <li class="active">
                                          <a
                                            href={`/admin/course/${i}/${params.page_size}`}
                                          >
                                            {i}
                                          </a>
                                        </li>
                                      ) : (
                                        <li>
                                          <a
                                            href={`/admin/course/${i}/${params.page_size}`}
                                          >
                                            {i}
                                          </a>
                                        </li>
                                      );
                                    })}
                                    {pagination.current_page !==
                                      pagination.last_page && (
                                        <li>
                                          <a
                                            href={`/admin/course/${Number(params.page) + 1
                                              }/${params.page_size}`}
                                          >
                                            <i class="fa fa-long-arrow-right"></i>
                                          </a>
                                        </li>
                                      )}
                                  </ul>
                                </div>
                              </div>
                              <div class="col-2">
                                <div class="pagination center">
                                  <form onSubmit={onChangePageSize}>
                                    <div class="form-group">
                                      <input
                                        type="number"
                                        class="form-control"
                                        placeholder={page_size}
                                        name="page_size"
                                        value={page_size}
                                        onChange={onChangePageSize}
                                        style={{ width: "100px" }}
                                      />
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      requestAdminAddCourse,
      requestAdminAllCourse,
      requestAdminCourse, requestAdminAllDegree,
      requestAdminDeleteCourse,
      requestAdminEditCourse,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Course);
